var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7341 6.60673C17.7105 6.2287 17.4754 5.89641 17.1267 5.74841C16.7781 5.60041 16.3757 5.66211 16.0874 5.90777L4.17366 16.0597C3.87182 16.3169 3.75048 16.7282 3.86437 17.1081C3.97826 17.4879 4.30586 17.7646 4.69943 17.8133L9.86013 18.4519C10.3032 18.5068 10.729 18.2612 10.9034 17.8502L12.6896 13.6422C12.9054 13.1338 13.4925 12.8967 14.0009 13.1124C14.5093 13.3282 14.7465 13.9153 14.5307 14.4237L12.7445 18.6317C12.57 19.0427 12.6891 19.5195 13.0364 19.8002L17.0807 23.0688C17.3892 23.3181 17.8157 23.3616 18.1681 23.1796C18.5205 22.9977 18.732 22.6247 18.7074 22.2289L17.7341 6.60673Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.70312) rotate(23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.db11d2c7b8da87e479ef5ba88afa6a72.svg";
export { ForwardRef as ReactComponent };